import Image from 'next/future/image';
import minus from '@/public/icons/cart/minus.svg';
import plusBlack from '@/public/icons/cart/plusBlack.svg';
import i18n from '@/settings/i18n';

const t = i18n.init();
const BUTTON_CLASS =
  'inline-flex justify-center items-center w-[20px] h-[20px] border rounded border-gray-700 disabled:opacity-40';

export type NumberInputValue = number | '';

export default function NumberInput(
  props: Omit<
    React.InputHTMLAttributes<HTMLInputElement>,
    'onChange' | 'value'
  > & {
    onChange: (value: number | '') => void;
    value: NumberInputValue;
    loading: boolean;
    index: number;
  },
) {
  const { min, max, index } = props;
  const { loading, className, value, onChange, ...otherProps } = props;

  return (
    <div className={`${className} items-center`}>
      <button
        onClick={(e) => {
          e.preventDefault();

          return !loading && value !== '' && onChange(value - 1);
        }}
        disabled={loading || value === min || value === ''}
        className={BUTTON_CLASS}
        id={`e2e-cart-line-${index}-minus`}
      >
        <span className="inline-flex h-[16px] w-[16px] items-center justify-center">
          <Image height={10} width={10} alt="minus" src={minus} />
        </span>
      </button>
      <input
        type="number"
        value={value}
        disabled={true}
        id={`e2e-cart-line-${index}-qty`}
        onChange={(e) => onChange(Number(e.target.value))}
        className="w-[30px] bg-transparent px-2 pt-0.5 text-center text-sm text-gray-700 opacity-100 outline-none disabled:text-gray-700"
        {...otherProps}
      />
      <button
        onClick={(e) => {
          e.preventDefault();

          return !loading && value !== '' && onChange(value + 1);
        }}
        disabled={loading || value === max || value === ''}
        title={value === max ? t`No more stock` : ''}
        className={BUTTON_CLASS}
        id={`e2e-cart-line-${index}-plus`}
      >
        <span className="inline-flex h-[16px] w-[16px] items-center justify-center">
          <Image height={10} width={10} alt="plusBlack" src={plusBlack} />
        </span>
      </button>
    </div>
  );
}
